import { ReactNode } from "react"
import "./index.less"

interface Iprop {
    name: string,
    onClick: () => void,
    icon: ReactNode
}

export default function MenuButton(props: Iprop) {
    return (
        <div className="menu-button" onClick={() => { props.onClick() }}>
            <div className="prefix-icon">
                {props.icon}
            </div>
            <div className="button-text">
                {props.name}
            </div>
        </div>
    )
}